module.exports = __webpack_public_path__ + "static/img/浙江警察学院.d7d79b6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/浙江警察学院.jpeg
// module id = HVKY
// module chunks = 1